// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Language Selector Styles */
.language-selector {
  position: relative;
  display: inline-block;
}

.current-language {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: var(--bg-primary);
  border: 2px solid var(--border-primary);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-secondary);
  font-family: inherit;
}

.current-language:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  background: var(--bg-secondary);
}

.flag-emoji {
  font-size: 1.1rem;
  line-height: 1;
}

.flag-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.8rem;
  height: 1.3rem;
  padding: 0 0.25rem;
  border-radius: 3px;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: var(--accent-primary, #3b82f6);
  color: #fff;
  flex-shrink: 0;
  line-height: 1;
}

.current-language .name {
  white-space: nowrap;
}

.language-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: var(--bg-primary);
  border: 2px solid var(--border-primary);
  border-radius: 8px;
  box-shadow: 0 4px 20px var(--shadow-primary);
  z-index: 1000;
  min-width: 200px;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 4px;
}

.language-option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: all 0.3s ease;
  color: var(--text-secondary);
  font-size: 0.9rem;
  font-family: inherit;
}

.language-option:hover {
  background: var(--bg-secondary);
  color: var(--accent-primary);
}

.language-option.active {
  background: var(--bg-tertiary);
  color: var(--accent-primary);
  font-weight: 600;
}

.language-option .flag-badge {
  flex-shrink: 0;
}

.language-option .name {
  flex: 1;
  white-space: nowrap;
}

/* Responsive Design */
@media (max-width: 768px) {
  .current-language .name {
    display: none;
  }
  
  .language-dropdown {
    min-width: 150px;
  }
  
  .language-option {
    padding: 0.6rem 0.75rem;
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .current-language {
    padding: 0.4rem 0.75rem;
    font-size: 0.8rem;
  }
  
  .language-dropdown {
    min-width: 120px;
  }
  
  .language-option {
    padding: 0.5rem 0.6rem;
    font-size: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/LanguageSelector.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,6BAA6B;EAC7B,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;EAC1C,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,6BAA6B;EAC7B,uCAAuC;EACvC,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF","sourcesContent":["/* Language Selector Styles */\n.language-selector {\n  position: relative;\n  display: inline-block;\n}\n\n.current-language {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: var(--bg-primary);\n  border: 2px solid var(--border-primary);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  font-family: inherit;\n}\n\n.current-language:hover {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n  background: var(--bg-secondary);\n}\n\n.flag-emoji {\n  font-size: 1.1rem;\n  line-height: 1;\n}\n\n.flag-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.8rem;\n  height: 1.3rem;\n  padding: 0 0.25rem;\n  border-radius: 3px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  background: var(--accent-primary, #3b82f6);\n  color: #fff;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.current-language .name {\n  white-space: nowrap;\n}\n\n.language-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  background: var(--bg-primary);\n  border: 2px solid var(--border-primary);\n  border-radius: 8px;\n  box-shadow: 0 4px 20px var(--shadow-primary);\n  z-index: 1000;\n  min-width: 200px;\n  max-height: 300px;\n  overflow-y: auto;\n  margin-top: 4px;\n}\n\n.language-option {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  font-family: inherit;\n}\n\n.language-option:hover {\n  background: var(--bg-secondary);\n  color: var(--accent-primary);\n}\n\n.language-option.active {\n  background: var(--bg-tertiary);\n  color: var(--accent-primary);\n  font-weight: 600;\n}\n\n.language-option .flag-badge {\n  flex-shrink: 0;\n}\n\n.language-option .name {\n  flex: 1;\n  white-space: nowrap;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .current-language .name {\n    display: none;\n  }\n  \n  .language-dropdown {\n    min-width: 150px;\n  }\n  \n  .language-option {\n    padding: 0.6rem 0.75rem;\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .current-language {\n    padding: 0.4rem 0.75rem;\n    font-size: 0.8rem;\n  }\n  \n  .language-dropdown {\n    min-width: 120px;\n  }\n  \n  .language-option {\n    padding: 0.5rem 0.6rem;\n    font-size: 0.8rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
